<template>
  <v-row justify="start" align="start">
    <v-col cols="12" class="py-0 align-center">
      <v-row>
        <v-radio-group
          v-model="selectedView"
          @change="onSelectView"
          row
          class="pa-0 pl-3 ma-0"
        >
          <v-radio
            label="Table"
            value="table"
            prepend-icon="mdi-view-list"
            class="py-0 my-0"
          >
            <template v-slot:label>
              <v-icon>mdi-view-list</v-icon>Table
            </template>
          </v-radio>
          <v-radio label="Day by Day" value="day_by_day" class="py-0 my-0">
            <template v-slot:label>
              <v-icon>mdi-calendar</v-icon>Day by Day
            </template>
          </v-radio>
          <v-radio label="Grouped" value="grouped" class="py-0 my-0">
            <template v-slot:label>
              <v-icon>mdi-group</v-icon>Grouped
            </template>
          </v-radio>
          <v-radio label="Pricing" value="pricing" class="py-0 my-0">
            <template v-slot:label>
              <v-icon>mdi-currency-usd</v-icon>Pricing
            </template>
          </v-radio>
          <v-radio label="Drag&Drop" value="drag" class="py-0 my-0">
            <template v-slot:label>
              <v-icon>mdi-drag</v-icon>Drag&Drop
            </template>
          </v-radio>
        </v-radio-group>
        <v-switch
          label="Show Quick Add"
          class="py-0 my-0"
          v-model="showQuickAdd"
          @change="onQuickAddChange"
        ></v-switch>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "itinerary-builder-settings",
  data() {
    return {
      selectedView: this.$store.getters.localSettings("itBuilderView"),
      showQuickAdd: this.$store.getters.localSettings(
        "itBuilderShowQuickAdd",
        true
      ),
      showCharges: this.$store.getters.localSettings(
        "itBuilderShowCharges",
        false
      ),
    };
  },
  methods: {
    onSelectView(view) {
      this.$store.dispatch("updateLocalSettings", { itBuilderView: view });
    },
    onQuickAddChange(show) {
      this.$store.dispatch("updateLocalSettings", {
        itBuilderShowQuickAdd: show,
      });
    },
    onShowChargesChange(show) {
      this.$store.dispatch("updateLocalSettings", {
        itBuilderShowCharges: show,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderSettings.vue